import { useCallback } from "react";

/**
 * Shared hook for smooth scrolling to page sections.
 * Centralizes scroll logic to avoid duplication across components.
 */
export const useScrollToSection = () => {
  const scrollToSection = useCallback((href: string) => {
    const element = document.querySelector(href);
    element?.scrollIntoView({ behavior: "smooth" });
  }, []);

  const scrollToTop = useCallback(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return { scrollToSection, scrollToTop };
};
